function escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function createPercentWildcardRegex(searchValue: string): RegExp {
    const pattern = searchValue
        .split('%')
        .map(escapeRegex)
        .join('.*');

    return new RegExp(pattern, 'i');
}

function matchesFormSelectSearchValue(value: unknown, inputValue: string): boolean {
    if (typeof value !== 'string') return false;

    const searchValue = inputValue;
    if (!searchValue) return true;

    return createPercentWildcardRegex(searchValue).test(value);
}

const optionCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

/** Sorts options A-Z by label (numbers in labels compare numerically). When groupBy is given, groups are kept together and sorted first. */
function sortOptionsByLabel<T>(options: readonly T[], getLabel: (option: T) => string, groupBy?: (option: T) => string): T[] {
    return [...options].sort((a, b) => (
        (groupBy ? optionCollator.compare(groupBy(a), groupBy(b)) : 0)
        || optionCollator.compare(getLabel(a), getLabel(b))
    ));
}

export {
    matchesFormSelectSearchValue,
    sortOptionsByLabel,
};
